<template>
    <div class="row">
        <div class="col-6">
            <label for="inputDataInicio">Data Inicial</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="dataInicio"><i class="fas fa-calendar-alt fa-fw"></i></span>
                </div>
                <input :type="format" :id="`${id}_inputDataInicio`" name="startDate" v-model="startDate" class="form-control" aria-label="DataInicio" aria-describedby="dataInicio" :required="required">
            </div>
        </div>
        <div class="col-6">
            <label for="inputDataFim">Data Final</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="dataFim"><i class="fas fa-calendar-alt fa-fw"></i></span>
                </div>
                <input :type="format" :id="`${id}_inputDataFim`" name="endDate" v-model="endDate" class="form-control" aria-label="DataFim" aria-describedby="dataFim" :required="required">
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {'id': String,
        'autofill': {
            type: String,
            default: 'monthly'
        },
        'required': {
            type: Boolean,
            default: true
		},
		'format': {
			type: String,
			default: 'date' // date, datetime-local or time
		}},
        data () {
            return {
                startDate: '',
                endDate: ''
            }
        },
        mounted() {
            switch(this.autofill){
                case 'monthly':
                    var firstOfTheMonth = moment().format('YYYY-MM-01')
					var now = moment().format('YYYY-MM-DD')
					
                    $('input[name=startDate]').val(firstOfTheMonth);
                    $('input[name=endDate]').val(now);

                    this.startDate = '';
                    this.endDate = '';
                break;
                case 'initialToday':
					var nowDateFormat;
					var endDateFormat;
					switch(this.format){
						case 'date':
							nowDateFormat = 'YYYY-MM-DD'
							endDateFormat = 'YYYY-MM-DD'
						break;
						case 'datetime-local':
							nowDateFormat = 'YYYY-MM-DD'
							endDateFormat = 'YYYY-MM-DDT23:59'
						break;
						case 'time':
							nowDateFormat = 'HH:mm'
							endDateFormat = 'HH:mm'
						break
					}
                    var now = moment().format(nowDateFormat);
                    var lastOfTheMonth = moment().endOf('month').format(endDateFormat);

                    $('input[name=startDate]').attr('min', now).val(now);
                    $('input[name=endDate]').attr('min', now).val(lastOfTheMonth);

                    this.startDate = '';
                    this.endDate = '';
				break;
				case 'onlyToday':
					var nowDateFormat;
					var endDateFormat;
					switch(this.format){
						case 'date':
							nowDateFormat = 'YYYY-MM-DD'
							endDateFormat = 'YYYY-MM-DD'
						break;
						case 'datetime-local':
							nowDateFormat = 'YYYY-MM-DD'
							endDateFormat = 'YYYY-MM-DDT23:59'
						break;
						case 'time':
							nowDateFormat = 'HH:mm'
							endDateFormat = 'HH:mm'
						break
					}
                    var now = moment().format(nowDateFormat);

                    $('input[name=startDate]').attr('max', now).val(now);
                    $('input[name=endDate]').attr('max', now).val(now);

                    this.startDate = '';
                    this.endDate = '';
                break;
            }
        }
    }
</script>
